<h3 class="text-xl font-bold mb-6">
  {{ 'project.steps.rfq.contractParameters' | transloco }}
  <app-directus-tooltip
    tooltipStyleClass="tooltip-bg-second-level"
    tooltipKey="project.steps.proposalParameters.contractParameters"
  ></app-directus-tooltip>
</h3>

<form [formGroup]="theForm">
  <div class="grid grid-cols-3 gap-4 p-5">
    <app-form-field-number
      [id]="'contractTotalTerms'"
      [fieldName]="'contractTotalTerms'"
      [label]="'contractParameters.contractTotalTerms' | transloco"
      [step]="1"
      [mode]="'integer'"
      [min]="1"
      [max]="10"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-number>

    <app-form-field-select-button
      id="solutionType"
      fieldName="solutionType"
      label="project.steps.proposalParameters.contractParameters.solutionType"
      [options]="solutionTypeOptions()"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-select-button>

    <app-form-field-select-button
      id="implementationMethod"
      fieldName="implementationMethod"
      label="project.steps.proposalParameters.contractParameters.implementationMethod"
      [options]="implementationMethodOptions()"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-select-button>

    <app-form-field-number
      [id]="'terminationPeriod'"
      [fieldName]="'terminationPeriod'"
      [label]="'contractParameters.terminationPeriod' | transloco"
      [step]="1"
      [mode]="'integer'"
      [min]="1"
      [max]="10"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-number>

    <app-form-field-select-button
      id="licenseModel"
      fieldName="licenseModel"
      label="project.steps.proposalParameters.contractParameters.licenseModel"
      [options]="licenseModelOptions()"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-select-button>

    <app-form-field-select-button
      id="paymentTerm"
      fieldName="paymentTerm"
      label="project.steps.proposalParameters.contractParameters.paymentTerm"
      [options]="paymentTermOptions()"
      [isReadOnly]="isReadOnly()"
    ></app-form-field-select-button>
  </div>

  @if (theForm.valid && hasChanges()) {
    <div class="flex justify-end gap-2 mt-4">
      <app-project-step-save-button
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (clicked)="onSubmit()"
      ></app-project-step-save-button>
    </div>
  }
</form>
